import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

/** Multi-select fixed-flag chips, shared between script- and page-level
 * labeling — the vocab differs, the interaction doesn't. */
export function FlagPicker({
  vocab,
  value,
  onChange,
}: {
  vocab: readonly string[];
  value: string[];
  onChange: (flags: string[]) => void;
}) {
  return (
    <ToggleGroup multiple variant="outline" className="flex-wrap" value={value} onValueChange={onChange}>
      {vocab.map(flag => (
        <ToggleGroupItem key={flag} value={flag}>
          {flag}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
